import React from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { Card, Button, Space } from "@masterteam/mt-design-react";
import { useHistory } from "react-router-dom";

import useIsAr from "../../../../Hooks/useIsAr";
import KPIItem from "./KPIItem";
import { getPolarityName, formatDate } from "../../../../helpers";
import "./style.scss";

function Information({
  item: {
    ArabicDescription,
    EnglishDescription,
    OwnerModel,
    ChampionModel,
    DataSource,
    EnglishEquation,
    ArabicEquation,
    EnglishAdditionalInformation,
    ArabicAdditionalInformation,
    UnitOfMeasure,
    Polarity,
    Frequency,
    CustomFrequency,
    Baseline,
    BaselineDate,
    CalculationMethod,
    KPIMeasures,
    HasAdminAccess,
    ArabicUnitDetails,
    EnglishUnitDetails,
    KPIType,
    Formula,
    ID,
    ObjectiveOwnerModel,
    HasNoTarget,
    HasNoBaseline,
  },
}) {
  const [polarities, kpiSources, frequencies, methods] = useSelector(
    ({ theme }) => [
      theme.Polarities.item.Items,
      theme.KPISource.item.Items,
      theme.Frequencies.item.Items,
      theme.CalculationMethods.item.Items,
    ]
  );
  const history = useHistory();
  const [isAr, locale] = useIsAr();

  const HasNoTargetBaseline = HasNoTarget || HasNoBaseline;

  function onEditClick() {
    history.push(`/administration/kpis?kpi=${ID}`);
  }

  // const lastMeasure = KPIMeasures && KPIMeasures[KPIMeasures.length - 1];
  const unitOfMeasure =
    UnitOfMeasure === "Percentage"
      ? "%"
      : isAr
      ? ArabicUnitDetails
      : EnglishUnitDetails;
  return (
    <Card className="kpi-information-section">
      <Space className="kpi-information-section_header" justify="between">
        <div>
          <FormattedMessage id="common.kpi-information" />
        </div>
        {/* <div className="d-flex">
          <FormattedMessage id="common.overall-target" />
          &nbsp;
          <strong>
            {lastMeasure?.Target || 0}
            {lastMeasure.MaxTarget ? " - " : " "}
            {lastMeasure.MaxTarget}&nbsp;
            {unitOfMeasure}
          </strong>
        </div> */}
        {HasAdminAccess ? (
          <div>
            <Button onClick={onEditClick}>
              <FormattedMessage id="kpi-details.update-kpi-details" />
            </Button>
          </div>
        ) : null}
      </Space>
      <div className="kpi-information-section_details">
        <div className="kpi-information-section_details_left">
          <KPIItem
            text={isAr ? ArabicDescription : EnglishDescription}
            label="kpi-info.kpi-description"
          />
          <KPIItem
            text={
              DataSource === "semi-auto"
                ? Formula
                : isAr
                ? ArabicEquation
                : EnglishEquation
            }
            label="kpi-info.kpi-equation"
          />
        </div>
        <div className="kpi-information-section_details_right">
          <KPIItem text={OwnerModel?.DisplayName} label="kpi-info.kpi-owner" />

          <KPIItem
            text={isAr ? KPIType.ArabicName : KPIType.EnglishName}
            label="kpi-info.kpi-type"
          />

          <KPIItem
            text={getPolarityName(kpiSources, DataSource, locale)}
            label="kpi-info.data-owner"
          />

          <KPIItem
            text={getPolarityName(polarities, Polarity, locale)}
            label="kpi-info.polarity"
          />

          <KPIItem
            text={ObjectiveOwnerModel?.DisplayName}
            label="kpi-info.objective-owner"
          />
          <KPIItem
            text={
              Frequency === "custom"
                ? CustomFrequency
                : getPolarityName(frequencies, Frequency, locale)
            }
            label="kpi-info.kpi-frequency"
          />

          <KPIItem
            text={
              UnitOfMeasure !== "Percentage" ? (
                unitOfMeasure
              ) : (
                <FormattedMessage id={`unit-Of-Measure.Percentage`} />
              )
            }
            label="kpi-info.kpi-unit-of-measure"
          />

          <KPIItem
            text={formatDate(BaselineDate)}
            label="common.baseline-date"
          />

          <KPIItem
            text={
              HasNoTargetBaseline
                ? "---"
                : `${Baseline}  ${UnitOfMeasure === "Percentage" ? "%" : ""}`
            }
            label="common.baseline-value"
          />

          <KPIItem
            text={getPolarityName(methods, CalculationMethod, locale)}
            label="kpi-info.calculation-method"
          />
        </div>
      </div>
    </Card>
  );
}

export default Information;
